<template>
	<div id="pageRoot">
		<p class="textBase appearAnimationB" id="text01" style="z-index: 6">
			Completa con las expresiones que aparecen abajo.
		</p>

		<p class="textBase appearAnimationA" id="text02" style="z-index: 6">
			Venancio vuela
		</p>
		<p class="textBase appearAnimationA" id="text03" style="z-index: 6">
			Venancio vuela
		</p>
		<p class="textBase appearAnimationA" id="text04" style="z-index: 6">
			Venancio no vuela
		</p>
		<p class="textBase appearAnimationA" id="text05" style="z-index: 6">
			Venancio no vuela
		</p>

		<div class="basicItem01" id="tag01" style="z-index: 3;">
			<p class="textBase tagText">
				como una mariposa.
			</p>
		</div>
		<div class="basicItem01" id="tag02" style="z-index: 3;">
			<p class="textBase tagText">
				como un pajarito.
			</p>
		</div>
		<div class="basicItem01" id="tag03" style="z-index: 3;">
			<p class="textBase tagText">
				bajito.
			</p>
		</div>
		<div class="basicItem01" id="tag04" style="z-index: 3;">
			<p class="textBase tagText">
				como un almohadón desesperado.
			</p>
		</div>

		
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01" class="pageElement" style=
		"z-index: 7"/>
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 id="inputField02" class="pageElement" style=
		"z-index: 7"/>

		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=3 id="inputField03" class="pageElement" style=
		"z-index: 7"/>
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=4 id="inputField04" class="pageElement" style=
		"z-index: 7"/>

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<img src="/pages/img/sordo/svgPage79Fixed.svg" class="pageElement" style="position: absolute; width: 765px; height: 391px; left: 47px; top: 37px;">
		<span class="footer-page footer-write"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
.tagText
{
position: absolute;
left: 0px;
right: 0px;
top: 5px;
bottom: 0px;

font-size: 36px;
line-height: 49px;
text-align: center;

color: #FEFAFA;
}

#text01
{
position: absolute;
width: 577px;
height: 35px;
left: 88px;
top: 113px;
}
#text02
{
position: absolute;
width: 221px;
height: 46px;
left: 107px;
top: 180px;
font-weight: 300;
font-size: 30px;
}
#text03
{
position: absolute;
width: 221px;
height: 46px;
left: 107px;
top: 252px;
font-weight: 300;
font-size: 30px;
}
#text04
{
position: absolute;
width: 300px;
height: 46px;
left: 107px;
top: 322px;
font-weight: 300;
font-size: 30px;
}
#text05
{
position: absolute;
width: 300px;
height: 46px;
left: 107px;
top: 396px;
font-weight: 300;
font-size: 30px;
}

#tag01{
position: absolute;
width: 400px;
height: 70.55px;
left: 24px;
top: 497px;
background-image: url(/pages/img/sordo/svgPage71TagLong.svg);
background-size: cover;
}
#tag02{
position: absolute;
width: 345px;
height: 70.55px;
left: 473px;
top: 492px;
background-image: url(/pages/img/sordo/svgPage71TagLong.svg);
background-size: cover;
}
#tag03{
position: absolute;
width: 139px;
height: 70.55px;
left: 864px;
top: 493px;
background-image: url(/pages/img/sordo/svgPage71TagShort.svg);
background-size: cover;
}
#tag04{
position: absolute;
width: 639px;
height: 70.55px;
left: 188px;
top: 586px;
background-image: url(/pages/img/sordo/svgPage79TagExtraLong.svg);
background-size: cover;
}

#inputField01
{
position: absolute;
width: 615px;
left: 317px;
top: 165px;
font-size: 33px;
}
#inputField02
{
position: absolute;
width: 615px;
left: 317px;
top: 237px;
font-size: 33px;
}
#inputField03
{
position: absolute;
width: 570px;
left: 362px;
top: 309px;
font-size: 33px;
}
#inputField04
{
position: absolute;
width: 570px;
left: 362px;
top: 382px;
font-size: 33px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p79/V78.mp4", "p79/V79.mp4", "p79/V80.mp4", "p79/V81.mp4", "p79/V82.mp4", "p79/V83.mp4", "p79/V84.mp4", 
      "p79/V85.mp4", "p79/V86.mp4", "p79/V87.mp4"]
    }
  }
}
</script>